// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3ONOL","inputDescription":"styles_inputDescription__1sqd6"};